// アコーディオンの要素を取得
const accordionToggles = document.querySelectorAll('.accordion-toggle');

// 各アコーディオンに対して処理を実行
accordionToggles.forEach(toggle => {
  // アコーディオンコンテンツの要素を取得
  const accordionContent = toggle.nextElementSibling;

  // メタフィールドの値が空の場合
  if (!accordionContent.textContent.trim()) {
    // アコーディオンを非アクティブにする
    toggle.disabled = true;
    toggle.classList.add('disabled');
  } else {
    // アコーディオンの開閉処理を実装
    toggle.addEventListener('click', () => {
      accordionContent.classList.toggle('open');
    });
  }
});